module.exports = __webpack_public_path__ + "img/cg.d89d8d48.svg";